import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Initialise } from './services/AxiosService';
import { createBrowserHistory } from "history";
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from './common/Store';
import { useEffect } from 'react';

const history = createBrowserHistory();

//Init Axios
Initialise();


function AppWithCallbackAfterRender() {
  useEffect(() => {
    console.log('rendered');
  });

  return <Provider store={Store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>,
        </Provider>
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);
root.render(<AppWithCallbackAfterRender />);

